import React from "react";
import { Button, Result } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { openNotification } from "../Notification";
import { UserProfile } from "../../Entities/UserProfile";

interface ResumeRawFilePreviewProps {
  userProfile: UserProfile;
}

const ResumeRawFilePreview: React.FC<ResumeRawFilePreviewProps> = ({
  userProfile,
}) => {
  const { userId, filename } = userProfile;
  const fileExtension = filename.split(".").pop()?.toLowerCase();
  const isPdf = fileExtension === "pdf";
  const fileUrl = `https://hiring-assistant-files.s3.ap-south-1.amazonaws.com/profile/${userId}/${filename}`;

  const handleDownload = () => {
    window.open(fileUrl, "_blank");
    openNotification("success", "Resume downloaded", "");
  };

  return isPdf ? (
    <iframe
      src={`${fileUrl}#toolbar=1&navpanes=1&scrollbar=1`}
      title="Resume Preview"
      className="resume-raw-iframe"
    />
  ) : (
    <div className="resume-unsupported">
      <Result
        status="error"
        title="Failed to load resume file."
        subTitle="This file can't be previewed because it's not a PDF. It may be a DOC or DOCX file. Please download it below to view."
        extra={
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            iconPosition="end"
            onClick={handleDownload}
          >
            Download Resume
          </Button>
        }
      />
    </div>
  );
};

export default ResumeRawFilePreview;